import { render, staticRenderFns } from "./Form13Layout.vue?vue&type=template&id=1fe9e1ac&scoped=true"
import script from "./Form13Layout.vue?vue&type=script&lang=ts"
export * from "./Form13Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=1fe9e1ac&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe9e1ac",
  null
  
)

export default component.exports